import { Textarea as ChakraTextarea, chakra } from '@chakra-ui/react'

const TextArea = chakra(ChakraTextarea)

export default TextArea
